<template>
  <div :style="{ '--duration': '150ms' }">
    <TransitionGroup :name="transition" tag="div" class="relative">
      <template v-for="(slot, i) of Object.keys($slots).sort((a, b) => order.indexOf(a) - order.indexOf(b))">
        <slot :name="slot" v-if="step === i" />
      </template>
    </TransitionGroup>
  </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
  order: string[]
}>()

const step = defineModel('step', { default: 0 })
const transition = ref('slide-left')

watch(step, (newValue, oldValue) => {
  transition.value = newValue > oldValue ? 'slide-left' : 'slide-right'
})

</script>